import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import PGMBoxBTNArea from './PGMBoxBTNArea';
import axios from 'axios';
import cookieCutter from 'cookie-cutter';

export default function pgm_Box(props) {
  const [swiperRef, setSwiperRef] = useState(null);
  const [maxPageCount, setMaxPageCount] = useState(0);
  const [naviCount, setNaviCount] = useState(1);

  // ✅ pgmIdList 만들기
  const pgmIdList = props.data.contents
      .map((item) => item.smr_pgm_id)
      .filter((id) => !!id);

  // ✅ 구독 상태 Map과 fetch 여부
  const [subscriptionMap, setSubscriptionMap] = useState({});
  const [subscriptionFetched, setSubscriptionFetched] = useState(false);

  useEffect(() => {
    if (swiperRef != null) {
      swiperRef.slideTo(0, 0);
    }
    setMaxPageCount(Math.ceil(props.data.contents.length / 5));
  }, []);

  // ✅ 구독 상태를 한 번만 가져오기
  useEffect(() => {
    const fetchSubscriptions = async () => {
      const LOGIN_JWT = cookieCutter.get('LOGIN_JWT');
      if (!LOGIN_JWT || pgmIdList.length === 0) return;

      const joinedIds = pgmIdList.join(',');
      const apiUrl = `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${joinedIds}?jwt-token=${LOGIN_JWT}`;

      try {
        const response = await axios.get(apiUrl);
        setSubscriptionMap(response.data || {});
        setSubscriptionFetched(true);
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    fetchSubscriptions();
  }, [pgmIdList.join(',')]);

  const handleClick = (a, b, c, d, e) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '큐레이션 모듈',
        moduleTitle: e,
        moduleSubTitle: '프로그램테마 큐레이션',
        moduleActive: 'C',
        moduleSeq: props.loc_idx,
        moduleItemSeq: c,
        programId: b.pgm_id,
        programTitle: b.pgm_nm,
        contentId: b.pgm_id,
        contentTitle: b.img_attr,
        contentNumber: '',
        contentType: 'PR',
      },
    });
  };

  return (
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a
                href={props.data.alllink_url}
                className="moduleTitleline-linkMore"
                style={{
                  visibility:
                      props.data.alllink_yn === 'Y' &&
                      props.data.alllink_url !== '' &&
                      props.data.alllink_url !== null
                          ? 'visible'
                          : 'hidden',
                }}
            >
              {props.data.alllink_title}
            </a>
          </div>
          <div className={`listModule_w_program program${props.loc_idx}`}>
            <button
                type="button"
                aria-label="다음 콘텐츠 보기"
                className="btnTypeList-Next swiper-button-next"
                onClick={() => setNaviCount(naviCount + 1)}
            >
            <span className="iconSvg_arrow">
              <i className="hide">다음</i>
            </span>
              <span className="pagingNumber_w">
              <strong className="pagingNumber-now">{naviCount}</strong>/
                {maxPageCount}
            </span>
            </button>

            <Swiper
                onSwiper={setSwiperRef}
                slidesPerView={5}
                spaceBetween={25}
                slidesPerGroup={5}
                loop={false}
                pagination={{
                  el: `.program${props.loc_idx} .swiper-pagination`,
                  clickable: false,
                }}
                navigation={{
                  nextEl: `.program${props.loc_idx} .swiper-button-next`,
                  prevEl: `.program${props.loc_idx} .swiper-button-prev`,
                }}
                modules={[Autoplay, Pagination, Navigation]}
                className="listModuleSlider"
                wrapperClass="SliderContent"
            >
              {props.data.contents.map((item, index) => (
                  <SwiperSlide key={`pgm_slide_${index}`}>
                    <div className="listModuleItem swiper-slide">
                      <div className="modulePosterWrap">
                        <Link href={item.link_url}>
                          <a
                              onClick={(e) =>
                                  handleClick(
                                      e,
                                      item,
                                      index,
                                      '인기',
                                      props.data.list_title
                                  )
                              }
                              className="mp_link"
                          >
                            <div className="mp_image_w">
                              <div className="mp_image_inner">
                                <img
                                    src={item.img_url}
                                    className="mp_image"
                                    alt={item.img_attr}
                                />
                              </div>
                              <div className="mb_label_w">
                                {item.free_yn === 'Y' && (
                                    <span className="mb_label_free">FREE</span>
                                )}
                                {item.age19_yn === 'Y' && (
                                    <span className="mb_label_19">19+</span>
                                )}
                              </div>
                            </div>
                            <div className="mp_info_w">
                              <span className="mpif_title">{item.pgm_nm}</span>
                              {item.new_yn === 'Y' && (
                                  <span className="mp_label_new">
                              <i className="hide">신작</i>
                            </span>
                              )}
                            </div>
                          </a>
                        </Link>

                        {/* ✅ 여기 수정된 부분 */}
                        <PGMBoxBTNArea
                            key={`mb_${index}`}
                            data={item}
                            pgmIdList={pgmIdList}
                            subscriptionMap={subscriptionMap}
                            subscriptionFetched={subscriptionFetched}
                            clickParams={props.clickParamLink}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
              ))}
            </Swiper>

            <div
                className="swiper-pagination"
                style={{ visibility: maxPageCount === 1 ? 'hidden' : 'visible' }}
            ></div>

            <button
                type="button"
                aria-label="이전 콘텐츠 보기"
                className="btnTypeList-Prev swiper-button-prev"
                onClick={() => setNaviCount(naviCount - 1)}
            >
            <span className="iconSvg_arrow">
              <i className="hide">이전</i>
            </span>
              <span className="pagingNumber_w">
              <strong className="pagingNumber-now">{naviCount}</strong>/
                {maxPageCount}
            </span>
            </button>
          </div>
        </div>
      </div>
  );
}
